import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";

export const GlobalDashboardService = {
  firstScreen,
  secondScreen,
  thirdScreen,
  materialResourceDashboard,
  trainingDashboard,
  complianceDashboard,
  capaDashboard,
  auditMeetingDashboard,
  incidentDashboard,
  workPermitDashboard,
  riskRegisterDashboard,
  vflDashboard,
  ohscDashboard,
  medicalDashboard,
  capasDashboard,
  defaultDashboard,
};

async function firstScreen(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/first-screen", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function secondScreen(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/second-screen", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function thirdScreen(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/third-screen", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function materialResourceDashboard(data) {
  try {
    const response = await RestMethod.GET("/global-dashboard/material-resource", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

/***************** EHS Dashboard ***********/
async function trainingDashboard(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/traning", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function complianceDashboard(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/compliance", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function capaDashboard(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/capa-dashboard", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function auditMeetingDashboard(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/audit-meeting", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function incidentDashboard(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/incident", data);
    if (response.data.status) {
      console.log("set data in store");
    }
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
async function vflDashboard(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/vfl-dashboard", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function ohscDashboard(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/ohse-dashboard", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function medicalDashboard(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/medical-dashboard", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function capasDashboard(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/capa-dashboard", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function defaultDashboard(data, checkUserType) {
  try {
    let url =
      checkUserType === "mine"
        ? "/global-dashboard/mine-dashboard"
        : checkUserType === "ro"
        ? "/global-dashboard/ro-dashboard"
        : "/global-dashboard/ho-dashboard";

    const response = await RestMethod.POST(url, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

// export async function getIncidentDashboard(filter) {
//   let url = "/global-dashboard/incident?";

//   if (filter) url += filter;

//   try {
//       const response = await RestMethod.GET(url);
//       return response.data;
//   } catch (error) {
//       console.log("error detected while fetching data from api");
//       return null;
//   }
// }

async function workPermitDashboard(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/work-permit", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function riskRegisterDashboard(data) {
  try {
    const response = await RestMethod.POST("/global-dashboard/risk-register", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
